const isApiMockActive =
  import.meta.env.NODE_ENV === "test" ||
  import.meta.env.VITE_API_MOCK_ACTIVE === "true";

export default isApiMockActive;
